import React from "react";

const Footer = () => {
  return (
    <div className="flex flex-col items-center justify-center bg-black rounded-xl min-h-[100vh] md:min-h-[70vh] relative">
      <div className="w-full md:absolute inset-0 flex flex-col justify-center items-center text-white">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-36 md:px-[32px]">
          <a
            href="mailto:info@leafwellfarm.com"
            className="flex flex-col items-center link-footer-2"
          >
            <div className="border-icon-footer">
              <img src="/icons/mail.svg" alt="" />
            </div>
            <p className="text-[14px] font-bold">Info@Leafwellfarm.com</p>
          </a>
          <a href="/" className="flex flex-col items-center space-y-4">
            <div className="p-1 rounded-xl px-2 min-h-[75px] flex flex-col items-center justify-center">
              {/* <img
                id="logo"
                src="/images/Logo.png"
                alt="Logo"
                className="max-h-[75px] md:max-w-full"
              /> */}
              <span className="text-[23px] font-[300] text-white font-barlow">Leafwell Farm</span>
              <div className="relative text-[32px] md:text-[60px] font-semibold leading-[100%] text-black text-center md:max-w-[8em] mb-[-0.17em] after:content-[''] after:absolute after:left-1/2 after:transform after:-translate-x-1/2 after:bottom-0 after:w-[54px] after:h-[2px] after:bg-[#fff] pb-2" />
            </div>
            {/* <div className="relative text-[32px] md:text-[60px] font-semibold leading-[100%] text-black text-center md:max-w-[8em] mb-[-0.17em] after:content-[''] after:absolute after:left-1/2 after:transform after:-translate-x-1/2 after:bottom-0 after:w-[54px] after:h-[3px] after:bg-[#bc9e59] pb-2" /> */}
            <p className="text-[#757575] italic">Live in Nature.</p>
          </a>
          <a href="sms:3473702217" className="link-footer-2">
            <div className="border-icon-footer">
              <img src="/icons/text.svg" alt="" className="max-h-[25px]" />
            </div>
            <p className="text-[14px] font-bold">347 370 2217</p>
          </a>
        </div>
      </div>
      <div className="flex justify-center flex-col md:flex-row text-center items-center gap-6 px-[32px] text-[#757575] font-bold text-[13px] md:absolute bottom-0 left-0 w-full py-6">
        <a href="/">
          © 2025 Leafwell Farm Real Estate NY, LLC. All rights reserved.
        </a>
        <div className="space-footer" />
        <a href="/terms-of-service">PRIVACY POLICY</a>
        <a href="/terms-of-service">TERMS OF SERVICE</a>
      </div>
    </div>
  );
};

export default Footer;
